import type { ApolloError } from "@apollo/client";

/** バックエンドのメッセージ断片（または完全一致）と、表示用メッセージの対応 */
const MESSAGE_MAP: ReadonlyArray<{ pattern: string; display: string }> = [
  {
    pattern: "capture session state is invalid",
    display: "検収の状態が不正です。",
  },
  {
    pattern: "assessment is invalid state",
    display: "検収の状態が不正です。",
  },
  {
    pattern: "CaptureSession already has a different assessment assigned.",
    display: "別の検収が既に割り当てられています。",
  },
  {
    pattern: "capture config generation failed",
    display: "カメラ選択に失敗しました。カメラを選択してください。",
  },
  // 以下 2 件は、古い一覧から検収を削除しようとして backend に弾かれた場合
  // 一覧の取得後に SMS 連携等で検収が開始・完了されていた
  {
    pattern: "assessment is not in the correct state to be terminated",
    display: "この検収は既に開始または完了しているため削除できません。",
  },
  // 別端末などで先に削除されていた
  {
    pattern: "assessment is already terminated",
    display: "この検収は既に削除されています。",
  },
];

/**
 * 文字列が MESSAGE_MAP のいずれかにマッチするか判定し、表示用メッセージを返す
 */
function matchDisplayMessage(source: string): string | null {
  for (const { pattern, display } of MESSAGE_MAP) {
    if (source.includes(pattern)) return display;
  }
  return null;
}

/**
 * ApolloError からユーザー向けエラーメッセージを取得する。
 * graphQLErrors のメッセージを優先し、なければ error.message を参照する。
 *
 * @param error - Apollo Error（GraphQL / network いずれも含む）
 * @returns 表示用メッセージ。マッチするものがない場合は null
 */
export function handleErrorMessage(error: ApolloError): string | null {
  // GraphQL エラーが存在する場合は各メッセージをチェック
  if (error.graphQLErrors?.length) {
    for (const gqlError of error.graphQLErrors) {
      const msg = gqlError.message;
      if (msg) {
        const display = matchDisplayMessage(msg);
        if (display) return display;
      }
    }
  }

  // フォールバック: Apollo が集約した message（networkError 含む）
  return matchDisplayMessage(error.message);
}
